// @ts-nocheck
(function() {
  'use strict';
  if (window.megaMenuUtils) return;

  function escapeHtml(s) {
    if (s === null || s === undefined || s === '') return '';
    const div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }
  function safeUrl(url) {
    if (url === null || url === undefined || typeof url !== 'string') return '#';
    const t = url.trim();
    if (t.indexOf('http://') === 0 || t.indexOf('https://') === 0 || t.indexOf('/') === 0 || t.indexOf('#') === 0 || t.indexOf('mailto:') === 0 || t.indexOf('tel:') === 0) return t;
    return '#';
  }
  function safeImgSrc(src) {
    if (src === null || src === undefined || typeof src !== 'string') return '';
    const t = src.trim();
    if (t.indexOf('http://') === 0 || t.indexOf('https://') === 0 || t.indexOf('/') === 0 || t.indexOf('data:') === 0) return t;
    return '';
  }
  function safeCssColor(value, fallback) {
    const def = fallback || '#f2f2f2';
    if (value === null || value === undefined || typeof value !== 'string') return def;
    const t = value.trim();
    if (/^#([0-9A-Fa-f]{3}){1,2}$/.test(t)) return t;
    return def;
  }

  window.megaMenuUtils = {
    escapeHtml: escapeHtml,
    safeUrl: safeUrl,
    safeImgSrc: safeImgSrc,
    safeCssColor: safeCssColor
  };
})();
